export const USER_TYPE = Object.freeze({
  DOCTOR: 1,
  CHIEF: 3,
  ASSISTANT: 4,
  REGIONAL: 5,
});

export const DOCTOR_TYPE = Object.freeze({
  REGULAR: 1,
  MAIN_OPERATOR: 2,
  SENIOR_DOCTOR: 3,
  SENIOR_RESIDENT: 4,
});

export const SCHEDULE_TYPE = Object.freeze({
  ON_DUTY: 1,
  ON_CALL: 7,
  ON_DUTY_REQUEST: 9,
});
